import { analyticsClick } from "@/lib/analytics/props";
import { Button } from "@photo-booth/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@photo-booth/ui/dialog";
import { ArrowRightIcon, Loader2 } from "lucide-react";
import { useQrPayment } from "@/hooks/useQrPayment";
import { useNavigate } from "react-router";
import { isQrPaymentEnabled } from "@/lib/configuration/payment";

interface Props {
  buttonProps: Omit<React.ComponentProps<typeof Button>, "onClick">;
}

export const AgreementModal: React.FC<Props> = ({ buttonProps }) => {
  const { handleGenerateQr, isGeneratingQr } = useQrPayment();
  const navigate = useNavigate();

  const handleProceedToPayment = () => {
    if (isQrPaymentEnabled()) {
      handleGenerateQr({
        onSuccess: (data) =>
          navigate(`/payment?transactionId=${data.transactionId}`),
      });
    } else {
      navigate(`/payment`);
    }
  };
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          {...buttonProps}
          {...analyticsClick({
            event: "continue-to-payment-button",
            feature: "payment",
            location: window.location.pathname,
          })}
        >
          <ArrowRightIcon className="w-4 h-4" />
          Next
        </Button>
      </DialogTrigger>
      <DialogContent onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle> Agreement </DialogTitle>
          <DialogDescription>
            This service is an automated online photobooth service.
          </DialogDescription>
        </DialogHeader>
        <p className="font-family-kanit">
          ผลลัพธ์ของภาพขึ้นอยู่กับคุณภาพของภาพต้นทาง เช่น แสง ความชัดเจน และตำแหน่งใบหน้า
        </p>
        <p className="font-family-kanit">
        ในกรณีที่ภาพต้นทางไม่เหมาะสม ระบบอาจไม่สามารถสร้างผลลัพธ์ได้อย่างถูกต้อง
        </p>
        <p className="font-family-kanit">การคืนเงินจะดำเนินการเฉพาะกรณีที่ระบบเกิดข้อผิดพลาดเท่านั้น </p>
        <p className="font-family-kanit">โปรดตรวจสอบให้แน่ใจ ก่อนดำเนินการชำระเงิน </p>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={handleProceedToPayment}
            disabled={isGeneratingQr}
          >
            {isGeneratingQr ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <ArrowRightIcon className="w-4 h-4" />
            )}
            Proceed to payment
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
